// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__OkeRa","Footer-List":"Footer_Footer-List__2NulY","Footer-Item":"Footer_Footer-Item__1NEOD","Footer-Link":"Footer_Footer-Link__WjfCq"};